import { render, staticRenderFns } from "./ContinuousAge.vue?vue&type=template&id=13c6bec4&scoped=true&"
import script from "./ContinuousAge.vue?vue&type=script&lang=js&"
export * from "./ContinuousAge.vue?vue&type=script&lang=js&"
import style0 from "./ContinuousAge.vue?vue&type=style&index=0&id=13c6bec4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c6bec4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VApp,VCard,VContainer,VFlex,VLayout})
